import { createStructuredSelector } from "reselect";
import {
    ROUTE_ADMINISTRATION_LIST,
    ROUTE_ADMINISTRATION_LIST_SUCCESS,
    ROUTE_ADMINISTRATION_LIST_ERROR,
    ROUTE_ADMINISTRATION_PAGE_SET,
    ROUTE_ADMINISTRATION_HEADER,
    ROUTE_ADMINISTRATION_SEARCH_SET,
    ROUTE_ADMINISTRATION_SEARCH_CHANGE,
    ROUTE_ADMINISTRATION_ADD_SET,
    ROUTE_ADMINISTRATION_ADD_MODAL_SET,
    ROUTE_ADMINISTRATION_ADD,
    ROUTE_ADMINISTRATION_ADD_SUCCESS,
    ROUTE_ADMINISTRATION_ADD_ERROR,
    ROUTE_ADMINISTRATION_ADD_CHANGE,
    ROUTE_ADMINISTRATION_EDIT_SET,
    ROUTE_ADMINISTRATION_EDIT_CHANGE,
    ROUTE_ADMINISTRATION_EDIT_MODAL_SET,
    ROUTE_ADMINISTRATION_DETAIL,
    ROUTE_ADMINISTRATION_DETAIL_SUCCESS,
    ROUTE_ADMINISTRATION_DETAIL_ERROR,
    ROUTE_ADMINISTRATION_UPDATE,
    ROUTE_ADMINISTRATION_UPDATE_SUCCESS,
    ROUTE_ADMINISTRATION_UPDATE_ERROR
} from "../actions";

export const NAME = 'routeAdministration';

export const RouteAdministrationList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: ROUTE_ADMINISTRATION_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const RouteAdministrationListSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_LIST_SUCCESS,
    payload: data
});

export const RouteAdministrationListError = (error) => ({
    type: ROUTE_ADMINISTRATION_LIST_ERROR,
    payload: error
});

export const RouteAdministrationPageSet = (data) => ({
    type: ROUTE_ADMINISTRATION_PAGE_SET,
    payload: data
});

export const RouteAdministrationHeader = (data) => ({
    type: ROUTE_ADMINISTRATION_HEADER,
    payload: data
})

export const RouteAdministrationSearchSet = (data) => ({
    type: ROUTE_ADMINISTRATION_SEARCH_SET,
    payload: data
});

export const RouteAdministrationSearchChangeSet = (data) => ({
    type: ROUTE_ADMINISTRATION_SEARCH_CHANGE,
    payload: data
});


export const RouteAdministrationAddChangeSet = (data) => ({
    type: ROUTE_ADMINISTRATION_ADD_CHANGE,
    payload: data
});

export const RouteAdministrationAddSet = (data) => ({
    type: ROUTE_ADMINISTRATION_ADD_SET,
    payload: data
});

export const RouteAdministrationAddModalSet = (data) => ({
    type: ROUTE_ADMINISTRATION_ADD_MODAL_SET,
    payload: data
});

export const RouteAdministrationAdd = (data) => ({
    type: ROUTE_ADMINISTRATION_ADD,
    payload: data
});

export const RouteAdministrationAddSuccess = (message) => ({
    type: ROUTE_ADMINISTRATION_ADD_SUCCESS,
    payload: message
});

export const RouteAdministrationAddError = (error) => ({
    type: ROUTE_ADMINISTRATION_ADD_ERROR,
    payload: error
});

export const RouteAdministrationEditSet = (data) => ({
    type: ROUTE_ADMINISTRATION_EDIT_SET,
    payload: data
});

export const RouteAdministrationEditChangeSet = (data) => ({
    type: ROUTE_ADMINISTRATION_EDIT_CHANGE,
    payload: data
});

export const RouteAdministrationEditModalSet = (data) => ({
    type: ROUTE_ADMINISTRATION_EDIT_MODAL_SET,
    payload: data
});

export const RouteAdministrationEditTabSet = (data) => ({
    type: ROUTE_ADMINISTRATION_EDIT_TAB_SET,
    payload: data
});

export const RouteAdministrationDetail = (data) => ({
    type: ROUTE_ADMINISTRATION_DETAIL,
    payload: data
});

export const RouteAdministrationDetailSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_DETAIL_SUCCESS,
    payload: data
});

export const RouteAdministrationDetailError = (error) => ({
    type: ROUTE_ADMINISTRATION_DETAIL_ERROR,
    payload: error
});

export const RouteAdministrationUpdate = (data) => ({
    type: ROUTE_ADMINISTRATION_UPDATE,
    payload: data
});

export const RouteAdministrationUpdateSuccess = (message) => ({
    type: ROUTE_ADMINISTRATION_UPDATE_SUCCESS,
    payload: message.message
});

export const RouteAdministrationUpdateError = (error) => ({
    type: ROUTE_ADMINISTRATION_UPDATE_ERROR,
    payload: error
});



const routeAdministration = (state) => state[NAME];

export const RouteAdministrationSelector = createStructuredSelector({
    routeAdministration
})
